import { useCallback, useState } from "react";
import { encryptStorage } from "../utils/encryptStorage";
import { useQueryClient } from "@tanstack/react-query";

const RECHARGE = 'RECHARGE'

const useRecharge = () => {
  const [recharge, setRecharge] = useState(null);
  const queryClient = useQueryClient();

  const addRecharge = useCallback(async (data) => {
    setRecharge(data);
    encryptStorage.setItem(RECHARGE, data);
  }, []);

  const deleteRecharge = useCallback(async () => {
    setRecharge(null);
    encryptStorage.removeItem(RECHARGE);
    queryClient.removeQueries(['checkoutData']);
  }, []);

  return {
    recharge,
    addRecharge,
    deleteRecharge,
  };
}

export default useRecharge;